var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTickGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.3333,
    fill: "#F5F5F5",
    stroke: "#1CCEDC",
    strokeWidth: 3.33333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2307 22.3021C57.7735 21.0537 55.5657 21.2902 54.4061 22.8191L35.5976 47.6164L25.5707 37.5968C24.2688 36.2958 22.1589 36.2962 20.8575 37.5976L19.8564 38.5987C18.5547 39.9004 18.5547 42.011 19.8564 43.3127L33.8742 57.3305C35.2919 58.7482 37.6313 58.6026 38.8623 57.0201L61.2617 28.2241C62.3544 26.8194 62.1509 24.804 60.7994 23.6461L59.2307 22.3021Z",
    fill: "#23E65A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickGreen);
export default __webpack_public_path__ + "static/media/circleTickGreen.040f63694261626065a177c5dac81410.svg";
export { ForwardRef as ReactComponent };